import { enhanceGLBridge, maskSmearBridge } from '@meitu/wasm-lib';
import { base64Kit } from '@/utils/base64-kit';
import { convertWebpToImage } from '@/utils/file-kit';
import { appendFilterId, deleteFilterPreview, fetchAlphaResult } from '@/utils/filter-kit';
import { ILayerProps, IMainLayerProps } from '@/version-types';
import { applyEnhanceGLResult } from './enhance';

export const handleBeforeSave = async (layer: ILayerProps, isAutoSave?: boolean) => {
    const data = layer.data as IMainLayerProps;

    data.url = convertWebpToImage(data.url);
    data.maskURL = convertWebpToImage(data.maskURL);
    data.cutoutMaskURL = convertWebpToImage(data.cutoutMaskURL);

    // 获取数据时，删除滤镜预览数据
    const filterID = deleteFilterPreview(layer);

    if (filterID) {
        // 将预览滤镜数据，默认应用到图层
        appendFilterId(layer, filterID, true);
    }
    // 获取预览滤镜的图片数据，执行上传
    const alphaResult = fetchAlphaResult(layer.id);

    if (alphaResult.base64) {
        data.url = base64Kit.getCode(alphaResult.base64, alphaResult.forceMd5);
    }

    // 隐藏保护区
    maskSmearBridge.enableRenderToView(false, false);
    const manager = await enhanceGLBridge.getManager();
    manager.processRender(true);

    // TODO: 这里目前在保存和下载会被执行两次，需要优化
    // 应用gl渲染的调整结果
    await applyEnhanceGLResult(layer);
    maskSmearBridge.enableRenderToView(true, false);
    manager.processRender(true);
    if (data.url) {
        data.url = await base64Kit.getRemoteUrlAsync(data.url);
    }
};
